// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2813":"d86ae85e","9116":"ae6e8aa2"}[chunkId] + ".chunk.css";
};